import template from './template.html'
import {orderBy} from 'lodash'

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasProvisionnominaconpagosSucursalesLista', {
    bindings: {
      nominas: '<',
    },
    template,
    controller: Controller,
  })

Controller.$inject = ['ContabilidadPolizasProvisionnominaconpagosSucursales', '$dialog']

function Controller (ContabilidadPolizasProvisionnominaconpagosSucursales, $dialog, $filter) {
  var $ctrl = this
  $ctrl.$onChanges = $onChanges
  $ctrl.exportar = exportar
  $ctrl.provision = []

  function $onChanges (changes) {
    if (changes.nominas) {
      $ctrl.$promise = ContabilidadPolizasProvisionnominaconpagosSucursales.get($ctrl.nominas)
        .then(function (response) {
          $ctrl.provision = orderBy(response.data.provision, ['id_nomina', 'departamento'])
          $ctrl.pagos = response.data.pagos
          $ctrl.polizas = response.data.polizas
          $ctrl.cuentascontables = response.data.cuentascontables
        })
    }
  }

  function exportar () {
    $dialog.show('contabilidad.polizas.exportar', {
      data: {provision: $ctrl.provision, pagos: $ctrl.pagos, cuentascontables: $ctrl.cuentascontables},
      // Se agregó ésta propiedad para indicar qué es lo que se va a exportar
      config: {
        nominas: $ctrl.nominas,
        archivo: 'Provision Nomina con pagos por Sucursales',
        tipo_poliza: 'provisionNominaconpagossucursales',
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/provisionnominaconpagossucursales/lista/component.js